'use es6';

import { HIDDEN } from 'customer-data-objects/property/AccessLevel';
export const RESTRICTED_FILTER_VALUE = 'RESTRICTED';
export const isFilterValueHasRestrictedProperties = filterValue => {
  const filterValueObject = filterValue || {};
  return filterValueObject.filterBranchOperator === RESTRICTED_FILTER_VALUE;
};
export const isFieldRestricted = accessLevel => {
  return accessLevel === HIDDEN;
};